module.exports = __webpack_public_path__ + "img/chatLogo5.ebd6407d.jpg";